require('./brokerAlerts.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

// @components
const CurrentAlert = require('./brokerOneAlert');

// @constants
const { BROKER_ALERT_DATE_FORMAT } = require('constants/index');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const sanitizeHelper = require('utilities/sanitizeHelper');

// @constants
const {
    BROKER_ALERT_CMY,
    BROKER_ALERT_CMN,
    BROKER_ALERT_VMN,
    BROKER_ALERT_VMY,
    BROKER_ALERT_BDV,
    BROKER_ALERT_BDP,
    BROKER_ALERT_SDV,
    BROKER_ALERT_SDP,
    EURO_SYMBOL
} = require('constants/index');

class BrokerAlerts extends React.Component {
    componentWillMount (){
        this.props.getAlerts();
    }

    getSummary() {
        const alert = this.props.brokerAlerts;
        switch (alert.get('conditionId')) {
            case BROKER_ALERT_CMY:
                return 'broker-alertsCmy';
            case BROKER_ALERT_CMN:
                return 'broker-alertsCmn';
            case BROKER_ALERT_VMN:
                return 'broker-alertsVmn';
            case BROKER_ALERT_VMY:
                return 'broker-alertsVmy';
            case BROKER_ALERT_BDV:
                return 'broker-alertsBdv';
            case BROKER_ALERT_BDP:
                return 'broker-alertsBdp';
            case BROKER_ALERT_SDV:
                return 'broker-alertsSdv';
            case BROKER_ALERT_SDP:
                return 'broker-alertsSdp';
            default:
                return '';
        }
    }

    buildAlertContent() {
        const alert = this.props.brokerAlerts;
        const summary = this.getSummary();

        const linkToBuy = alert.get('buyButtonUrl');
        const aDate = alert.get('endDate');
        const exchangeName = alert.get('exchangeName');
        const stockName = alert.get('stockName');

        const buy = formatText('broker-myInvestmentsBuyLink');

        const aStockName = `${stockName} (${exchangeName})`;
        const sanitizeStockName = sanitizeHelper.sanitizeData(aStockName);

        const date = moment(aDate).locale(DATE_PICKER_CUSTOM_LOCALE).format(BROKER_ALERT_DATE_FORMAT);

        const percentageConditionsIds = ['VMN', 'VMY', 'BDV', 'SDV'];
        let value;

        if ( percentageConditionsIds.indexOf(alert.get('conditionId')) === -1 ){
            value = `${formatAmount(alert.get('conditionValue'))} ${EURO_SYMBOL}`;
        } else {
            value = `${alert.get('conditionValue')} %`;
        }

        let buyButton;

        if (alert.get('buyButtonUrl')) {
            buyButton = (
                <div className="broker-alerts__link">
                    <OKButton
                        modifier="secondary"
                        size="small"
                        to={linkToBuy}
                    >
                        {buy}
                    </OKButton>
                </div>
            );
        }

        return (
            <div className="broker-alerts__current-alert">
                <div className="broker-alerts__current-alert-icon">
                    <OKIconIllustrative icon="alert" product="wealth" />
                    {buyButton}
                </div>
                <CurrentAlert
                    myDate={date}
                    stockName={sanitizeStockName}
                    summary={formatText(summary, [value])}
                />
            </div>
        );
    }

    render() {
        const alert = this.props.brokerAlerts;
        const alerts = formatText('broker-alerts');

        let alertContent;
        let newAlertButton = <i className="icon broker-alerts__settings icon-preferencias"/>

        if (alert.get('stockName')) {
            alertContent = this.buildAlertContent();
        } else {
            alertContent = (
                <div className="broker-alerts__empty-alert">
                    <i className="icon empty-state__image empty-state-alert-wealth"></i>
                    <FormattedText value="broker-alertsEmpty"/>
                </div>
            );
            newAlertButton = (
                <OKTooltip
                    target={<i className="icon broker-alerts__settings icon-preferencias"/>}
                    content="broker-alertsTooltip"
                    offset={[0, -15]}
                    disableAdjustment={true}
                />
            );
        }

        const alertSettings = (
            <OKLink onClick={this.props.onClickAlertsTooltip} modifier="emphasize" to="/myprofile/broker/alertsConfig/">
                {newAlertButton}
            </OKLink>
        );

        return (
            <ContentBox
                id="brokerAlerts"
                title={alerts}
                smallTitle={true}
                rightContent={alertSettings}
                customClassName="broker-alerts"
                modifier="complementary"
                product="wealth"
            >
                <div className="clearfix">
                    {alertContent}
                </div>
            </ContentBox>
        );
    }
}

BrokerAlerts.propTypes = {
    brokerAlerts: PropTypes.object.isRequired,
    getAlerts: PropTypes.func.isRequired,
    onClickAlertsTooltip: PropTypes.func
};

module.exports = BrokerAlerts;
